"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "molini-di-triora": {
    "177baa19": [{
      "hkey": "796c46f0",
      "slug": "molini-di-triora",
      "name": "Molini di Triora",
      "primary": true,
      "skipSearch": false
    }],
    "aigovo": [{
      "hkey": "796c46f0",
      "slug": "molini-di-triora",
      "name": "Molini di Triora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e2194a2": [{
      "hkey": "796c46f0",
      "slug": "molini-di-triora",
      "name": "Molini di Triora",
      "primary": true,
      "skipSearch": false
    }],
    "gavano": [{
      "hkey": "796c46f0",
      "slug": "molini-di-triora",
      "name": "Molini di Triora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "59bd1d4f": [{
      "hkey": "796c46f0",
      "slug": "molini-di-triora",
      "name": "Molini di Triora",
      "primary": true,
      "skipSearch": false
    }],
    "perallo": [{
      "hkey": "796c46f0",
      "slug": "molini-di-triora",
      "name": "Molini di Triora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;